/**
 * Prüft, ob der Wert innerhalb der min/max-Schranken liegt.
 */
function _inBounds(min, max, val) {
    return (val >= min ? (val <= max ? val : max) : min);
}

/**
 * Berechnet die maximale Anzahl an Einträgen, sowie das
 * erste sichtbare Item und das letzte sichtbare Item.
 */
function _calculate(paging) {
    var _OptimizedEntries, _MaxPages;
    paging.maxPages = (_MaxPages = Math.ceil(paging.maxEntries / paging.numPerPage)) > 0 ? _MaxPages : 1;
    paging.firstVisibleItem = ((paging.currentPage - 1) * paging.numPerPage) + 1;
    paging.lastVisibleItem = ((_OptimizedEntries = paging.firstVisibleItem + paging.numPerPage) > paging.numPerPage * paging.maxPages ? paging.maxEntries : _OptimizedEntries - 1);
}

function CPaging(currentPage, maxEntries, numPerPage) {
    this.setMaxEntries(maxEntries);
    this.setNumPerPage(numPerPage);
    this.moveTo(currentPage);
}

CPaging.prototype = {

    /**
     * Die aktuelle Seitennummer
     * @type int
     * @default 1
     */
    currentPage: 1,

    /**
     * Die maximale Anzahl an Einträgen
     * @type int
     * @default 0
     */
    maxEntries: 0,

    /**
     * Die Anzahl an Einträgen pro Seite
     * @type int
     * @default 4
     */
    numPerPage: 4,

    /**
     * Die errechnete Anzahl an Seiten
     * @type int
     * @default 1
     */
    maxPages: 1,

    /**
     * Die errechnete Startposition auf der Seite
     * @type int
     * @default null
     */
    firstVisibleItem: null,

    /**
     * Die errechnete Endposition auf der Seite
     * @type int
     * @default null
     */
    lastVisibleItem: null,

    /**
     * @class Klasse zur Erstellung einer Seitennummerierung.
     * @constructor
     * @param int CurrentPage Die aktuelle Seite
     * @param int MaxEntries  Die maximale Anzahl an Einträgen.
     * @param int NumPerPage  Die Anzahl der Einträge pro Seite.
     */
    constructor: CPaging,

    /**
     * Ändert die maximale Anzahl an Einträgen
     * @param int n Die Anzahl der Einträge
     */
    setMaxEntries: function (n) {
        if (n === this.maxEntries) {
            return;
        }
        this.maxEntries = _inBounds(0, n, n);
        _calculate(this);
    },

    /**
     * Ändert die maximale Anzahl an Einträgen auf einer Seite
     * @param int n Die neue Anzahl
     */
    setNumPerPage: function (n) {
        if (n === this.numPerPage) {
            return;
        }
        this.numPerPage = _inBounds(0, this.maxEntries, n);
        _calculate(this);
    },

    /**
     * Springt zur Seite X zwischen 0 und maxPages
     * @param int n Die Seitenzahl
     */
    moveTo: function (n) {
        if (n === this.currentPage) {
            return;
        }
        this.currentPage = _inBounds(1, this.maxPages, n);
        _calculate(this);
    },

    getPrevPage: function (n) {
        return _inBounds(1, this.maxPages, this.currentPage - (n ? n : 1));
    },

    /**
     * Springt zu der/den vorige(n) Seite(n).
     * @param int (optional) bestimmt, wie viele Seiten übersprungen werden sollen
     */
    prev: function (n) {
        this.moveTo(this.currentPage - (n ? n : 1));
    },

    getNextPage: function (n) {
        return _inBounds(1, this.maxPages, this.currentPage + (n ? n : 1));
    },

    /**
     * Springt zu der/den nächste(n) Seite(n).
     * @param int (optional) bestimmt, wie viele Seiten übersprungen werden sollen
     */
    next: function (n) {
        this.moveTo(this.currentPage + (n ? n : 1));
    },

    getFirstPage: function () {
        return 1;
    },

    /**
     * Springt zur ersten Seite
     */
    first: function () {
        this.moveTo(1);
    },

    getLastPage: function () {
        return this.maxPages;
    },

    /**
     * Springt zur letzten Seite
     */
    last: function () {
        this.moveTo(this.maxPages);
    }
};

var PagingModel = Backbone.Model.extend({
    initialize: function () {
    },

    fromResultList: function (ResultListModel, config) {
        var self = this;

        var itemCount = ResultListModel.get('AddressItems').length + ResultListModel.get('AddressShadowItems').length;

        var Paging = ResultListModel.get('Paging'),
            pagingObj = new CPaging(Paging.Page, Paging.Count, config.ItemsPerPage),
            rangeItems = _.range(pagingObj.getPrevPage(4), pagingObj.getNextPage(4) + 1);

        var PagingRange = _.map(rangeItems, function (page, index) {
            return {page: page, active: page === Paging.Page, text: page};
        });

        if (PagingRange.length === 0) {
            PagingRange.push({page: 1, active: true, text: 1});
        }

        //            PagingRange.unshift({ page: pagingObj.getPrevPage(), active: pagingObj.getPrevPage() === Paging.Page, text: "&lt;" });
        //            PagingRange.unshift({ page: pagingObj.getFirstPage(), active: pagingObj.getFirstPage() === Paging.Page, text: "◀" });
        //            PagingRange.push({ page: pagingObj.getNextPage(), active: pagingObj.getNextPage() === Paging.Page, text: "&gt;" });
        //            PagingRange.push({ page: pagingObj.getLastPage(), active: pagingObj.getLastPage() === Paging.Page, text: "▶" });

        var searchData = ResultListModel.get('SearchData');

        self.set('SingleSlotGeo', '');
        self.set('BC', searchData.Branches);
        self.set('LocX', searchData.Location.XCoord);
        self.set('LocY', searchData.Location.YCoord);
        self.set('MaxPages', config.MaxPages * 1);
        self.set('ItemsPerPage', config.ItemsPerPage * 1);
        self.set('Paging', Paging);
        self.set('AddressItemsCount', itemCount * 1);
        self.set('Range', PagingRange);

        return this;
    }
});
